import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'fa'
  },
  theme: {
    themes: {
      light: {
        primary: '#000000',
        accent: '#24aff0',
        dark: '#4d4d4d',
        light: '#808080',
        paid: '#6c87ff'
      }
    }
  },
  lang: {
    locales: { es },
    current: 'es'
  }
})
